// extracted by mini-css-extract-plugin
export default {"dialogHeader":"CWarsAttemptsDialog_dialogHeader_d0ef6","dialogBody":"CWarsAttemptsDialog_dialogBody_d5425","onAttemptsMessage":"CWarsAttemptsDialog_onAttemptsMessage_b16d0"};